import type { AxiosInstance } from 'axios';
import { BILLING_ENDPOINTS as E } from '../endpoints';
import type {
  AccountDevices,
  LicenseDevice,
  OrgMemberDevices,
  RenameDeviceRequest,
  RevokeLostDeviceRequest,
} from '../types/license-device.type';

/**
 * 디바이스락 호출부. 본인(마이페이지)과 조직 관리자(기업콘솔)가 같은 계약을 본다.
 * 한도·교체 횟수 판정은 서버가 한다 — 화면은 응답의 release 를 그대로 보여주기만 한다.
 */
export function createLicenseDeviceApi(apiClient: AxiosInstance) {
  return {
    listMine: () =>
      apiClient.get<AccountDevices>(E.myDevices).then((r) => r.data),

    /** 본인 기기 별명 변경 — 교체 횟수와 무관. */
    renameMine: (deviceId: string, body: RenameDeviceRequest) =>
      apiClient
        .patch<LicenseDevice>(E.myDevice(deviceId), body)
        .then((r) => r.data),

    /** 본인 해제 — 교체 횟수 1회 차감. */
    releaseMine: (deviceId: string) =>
      apiClient
        .delete<LicenseDevice>(E.myDevice(deviceId))
        .then((r) => r.data),

    listOrg: (orgId: string) =>
      apiClient
        .get<OrgMemberDevices[]>(E.orgDevices(orgId))
        .then((r) => r.data),

    /** 관리자 해제 — 해당 구성원의 교체 횟수에서 차감. */
    releaseOrg: (orgId: string, deviceId: string) =>
      apiClient
        .delete<LicenseDevice>(E.orgDevice(orgId, deviceId))
        .then((r) => r.data),

    /** 분실·퇴사 회수 — 교체 횟수 미차감, 사유 필수, 조직 단위 상한. */
    revokeLost: (orgId: string, deviceId: string, body: RevokeLostDeviceRequest) =>
      apiClient
        .post<LicenseDevice>(E.orgDeviceRevoke(orgId, deviceId), body)
        .then((r) => r.data),
  };
}

export type LicenseDeviceApi = ReturnType<typeof createLicenseDeviceApi>;
